'use client';
import { Breakpoint } from '@/features/breakpoint';
import { useBreakpoint } from '@/features/breakpoint/contexts';
import { useRouter } from '@/navigation';
import { siteService } from '@/services/site.service';
import {  useAuthToken } from '@/store/auth';
import { LicenseeTypeEnums } from '@nf/types/site';
import { useEffect } from 'react';

// athena模式若為before user強制導轉至主頁
export const JupiterSportsbookProvider = ({ children }: { children: React.ReactNode }) => {
	const authToken = useAuthToken();
	const router= useRouter();
	const { breakpoint } = useBreakpoint();
	const isBefore = !Boolean(authToken);
	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
	const shouldShowSportsbook = !(isBefore && isAthena && breakpoint <= Breakpoint.sm);
	useEffect(() => {
		if (!shouldShowSportsbook) {
			router.replace('/')
		}
	}, [isBefore, isAthena, breakpoint]);

	if (shouldShowSportsbook) {
		return children
	} else {
		return null
	}
}